import { apiSlice } from "../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        searchAll: builder.query({
            query: (queryParam) => ({
                url: `/search/all`,
                method: "GET",
                params: {
                    query: queryParam,
                },
            }),
        }),
    }),
});

export const { useSearchAllQuery } = sqlApiSlice;
